<template>
  <div class="fan-drawer">
    <div
      v-if="modalClose"
      :class="modeClass"
      @click="closeClick"
    >
    </div>
    <div
      :class="mainClass"
      :style="mainStyle"
    >
      <div>
        <div class="drawer-header">
          <div class="drawer-header-left">
            <!-- <div class="drawer-header-icon">
                <i class="el-icon-tickets"></i>
              </div> -->
            <div class="drawer-header-left-text">
              <div class="drawer-header-left-title">{{title}}</div>
              <div class="drawer-header-left-title-no">
                {{titleNo}}
              </div>
            </div>
          </div>
          <div class="drawer-header-right">
            <slot name="drawer-operation" />
            <div
              v-if="isRefresh"
              class="close-header"
              @click="refreshClick()"
            >
              <icon-svg name="icon_refresh" />
            </div>
            <div
              v-show="closable"
              class="close-header"
              @click="closeClick"
            >
              <icon-svg name="icon_close" />
            </div>
          </div>
        </div>
      </div>
      <!-- 需要同时固定在顶部的额外组件 -->
      <div class="fixed-header" v-if="isFixedH">
        <slot name="fixed-drawer-header" />
      </div>
      <div class="drawer-body">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 是否打开
    visible: {
      type: Boolean,
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 标题对应的编号
    titleNo: {
      type: [String, Number],
      default: '',
    },
    // 控制遮罩是否可以点击隐藏抽屉组件
    wrapperClosable: {
      type: Boolean,
      default: true,
    },
    // 抽屉滑动方向
    direction: {
      type: String,
      default: 'right',
    },
    width: {
      type: String,
      default: '50%',
    },
    // 抽屉遮罩层是否显示
    modal: {
      type: Boolean,
      default: true,
    },
    // 抽屉遮罩层是否关闭
    modalClose: {
      type: Boolean,
      default: true,
    },
    // 是否显示关闭按钮
    closable: {
      type: Boolean,
      default: true,
    },
    // 是否显示刷新按钮
    isRefresh: {
      type: Boolean,
      default: true,
    },
    // 是否需要固定在顶部的额外组件
    isFixedH: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      deep: true,
      handler() {
        if (this.visible) {
          this.$emit('open');
        }
      },
      immediate: true,
    },

  },
  computed: {
    modeClass() {
      return {
        'fan-drawer-open-mode': this.modal && this.visible,
        'fan-drawer-close-mode': !this.modal && this.visible,
      };
    },
    mainClass() {
      return {
        'fan-main': this.visible,
        'fan-drawer-open-content': this.direction === 'left' && this.visible,
        'fan-drawer-close-content': this.direction === 'left' && !this.visible,
        'fan-drawer-open-content-right': this.direction !== 'left' && this.visible,
        'fan-drawer-close-content-right': this.direction !== 'left' && !this.visible,
      };
    },
    mainStyle() {
      return {
        width: this.width,
        right: this.visible ? '0' : `-${this.width}`,
      };
    },
  },
  methods: {
    // 刷新
    refreshClick() {
      this.$emit('refresh');
    },
    // 关闭
    closeClick() {
      this.$emit('update:visible', false);
    },
    modeClick() {
      if (this.wrapperClosable) {
        this.handleClose();
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .fan-drawer{
    z-index: 1993;
    position: relative;
    .fan-main{
      display: flex;
      flex-direction: column;
      box-shadow: 0 8px 10px -5px rgba(0,0,0,.2),
      0 16px 24px 2px rgba(0,0,0,.14),
      0 6px 30px 5px rgba(0,0,0,.12);
      overflow: hidden;
      min-width: 500px;
    }
    .fixed-header {
      padding: 16px 32px;
    }
    .drawer-body {
      padding: 16px 32px;
      overflow: auto !important;
    }
    .drawer-header{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 28px 32px;
      box-shadow: 1px 0px 11px 0px rgba(39, 39, 40, 0.06);
      &-icon {
        width: 45px;
        height: 45px;
        line-height: 1.5;
        padding: 0;
        margin: 0;
        text-align: center;
        font-size: 35px;
        margin-right: 5px;
        background-color: #1284d6;
        color: #fff;
        border-radius: 5px;
      }
      &-left{
        display: flex;
        &-text{
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }
        &-title{
          flex:1;
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #272728;
          line-height: 1.5;
        }
        &-title-no{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4D4F51;
          line-height: 1.5;
        }
      }
      &-right{
        display: flex;
        justify-content: space-between;
        margin-left: 15px;
        align-items: center;
      }
    }
    &-close-content,&-open-content,
    &-close-content-right,
    &-open-content-right,
    &-close-mode,
    &-open-mode{
      position: fixed;
      top: 0;
      height: 100%;
    }
    &-close-content,
    &-open-content,
    &-close-content-right,
    &-open-content-right{
      width: 50%;
      background: #fff;
      z-index: 99
    }
    &-open-mode,
    &-close-mode{
      opacity: 0.8;
      z-index: 9;
      width: 100%;
      right: 0;
      left: 0;
    }
    &-close-content{
      opacity:0;
      left: 0%;
      transform: translate3d(-100%, 0, 0);
      transition: all .5s;
    }
    &-open-content{
      opacity:1;
      left: 0%;
      transform: translate3d(0, 0, 0);
      transition:all  .5s;
    }
    &-close-content-right{
      right: -50%;
      transition: right .5s;
    }
    &-open-content-right{
      right: 0;
      transition: right .5s;
    }
    &-close-mode{
      opacity:0;
      transition: opacity .5s;
    }
    &-open-mode{
      opacity: 0.7;
      transition: opacity .5s;
      background: #222222;
    }
    .close-header{
      cursor: pointer;
      font-size: 24px;
      margin-left: 16px;
    }
    .close-header:hover{
      color: $brand-primary-tap;
    }
  }
</style>
